export default __webpack_public_path__ + "static/IPhone_App-MockUp-ebba4195313143d9475537761be9e3f0.webp";